import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  PostWebV1UpdateConfigApiRes,
  IGetAppConfigLatestParams,
  IGetAppConfigLatestRes,
  IGetOrgTreeBySsoItem,
} from './index.d';

/**
 * 更新配置 — 添加
 * @see https://yapi.baibu.la/project/996/interface/api/73304
 *
 * @请求方法: POST
 * @请求地址: /manage-app/web/v1/update-config
 * @更新时间: 2021-04-27 15:48:36
 */
export const postWebV1UpdateConfigApi = (data: PostWebV1UpdateConfigApiRes) => {
  return http.post({
    url: '/manage-app/web/v1/update-config',
    data,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

export const getAppConfigLatest = (params: IGetAppConfigLatestParams) => {
  return http.get<IGetAppConfigLatestRes>({
    url: '/manage-app/web/v1/update-config/getLatest',
    params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

export const getOrganizationInfosTree = () => {
  return http.get<any>({
    url: '/cuckoo/web/v1/organization/getOrganizationInfosTree',
    server: DOMAIN_SYSTEM_ENUM.TIANGONG,
    loading: true,
  });
};

export const getOrganizationTreeBySso = () => {
  return http.post<IGetOrgTreeBySsoItem[]>({
    url: '/sso-center/admin/orgs/list',
    loading: true,
    config: {
      withCredentials: false,
    },
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
